var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8531_40129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16514 -0.161713C4.82514 -0.161713 3.84834 -0.158266 3.65858 -0.142511C2.97318 -0.0855222 2.54666 0.022433 2.08202 0.253825C1.72394 0.431697 1.44154 0.637857 1.16282 0.926881C0.655225 1.45394 0.347593 2.10229 0.236233 2.87312C0.182089 3.2472 0.166345 3.32352 0.163145 5.23488C0.161914 5.87199 0.163145 6.71045 0.163145 7.83504C0.163145 11.1731 0.166836 12.1493 0.182833 12.3389C0.238207 13.006 0.342802 13.4257 0.564305 13.8849C0.987617 14.7637 1.79608 15.4235 2.74846 15.6697C3.07826 15.7546 3.44248 15.8014 3.9101 15.8235C4.10821 15.8321 6.12754 15.8383 8.14802 15.8383C10.1685 15.8383 12.1891 15.8358 12.3823 15.826C12.9237 15.8005 13.2381 15.7583 13.5857 15.6684C14.058 15.5473 14.4981 15.3245 14.8754 15.0156C15.2526 14.7067 15.5579 14.3191 15.7699 13.88C15.9871 13.4319 16.0972 12.9962 16.147 12.3639C16.1579 12.226 16.1624 10.0281 16.1624 7.83301C16.1624 5.63765 16.1575 3.44373 16.1467 3.30581C16.0971 2.66341 15.9864 2.23141 15.7622 1.77477C15.5782 1.40088 15.374 1.12171 15.0774 0.836291C14.5481 0.330643 13.9009 0.0229146 13.1296 -0.0883494C12.756 -0.142385 12.6814 -0.158386 10.7692 -0.161709L8.16514 -0.161713Z",
    fill: "url(#paint0_radial_8531_40129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16514 -0.161713C4.82514 -0.161713 3.84834 -0.158266 3.65858 -0.142511C2.97318 -0.0855222 2.54666 0.022433 2.08202 0.253825C1.72394 0.431697 1.44154 0.637857 1.16282 0.926881C0.655225 1.45394 0.347593 2.10229 0.236233 2.87312C0.182089 3.2472 0.166345 3.32352 0.163145 5.23488C0.161914 5.87199 0.163145 6.71045 0.163145 7.83504C0.163145 11.1731 0.166836 12.1493 0.182833 12.3389C0.238207 13.006 0.342802 13.4257 0.564305 13.8849C0.987617 14.7637 1.79608 15.4235 2.74846 15.6697C3.07826 15.7546 3.44248 15.8014 3.9101 15.8235C4.10821 15.8321 6.12754 15.8383 8.14802 15.8383C10.1685 15.8383 12.1891 15.8358 12.3823 15.826C12.9237 15.8005 13.2381 15.7583 13.5857 15.6684C14.058 15.5473 14.4981 15.3245 14.8754 15.0156C15.2526 14.7067 15.5579 14.3191 15.7699 13.88C15.9871 13.4319 16.0972 12.9962 16.147 12.3639C16.1579 12.226 16.1624 10.0281 16.1624 7.83301C16.1624 5.63765 16.1575 3.44373 16.1467 3.30581C16.0971 2.66341 15.9864 2.23141 15.7622 1.77477C15.5782 1.40088 15.374 1.12171 15.0774 0.836291C14.5481 0.330643 13.9009 0.0229146 13.1296 -0.0883494C12.756 -0.142385 12.6814 -0.158386 10.7692 -0.161709L8.16514 -0.161713Z",
    fill: "url(#paint1_radial_8531_40129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15903 10.3319C9.56284 10.3319 10.7009 9.19392 10.7009 7.7901C10.7009 6.38628 9.56284 5.24826 8.15903 5.24826C6.75521 5.24826 5.61719 6.38628 5.61719 7.7901C5.61719 9.19392 6.75521 10.3319 8.15903 10.3319Z",
    stroke: "white",
    strokeWidth: 1.13732
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6096 2.42639H5.71074C4.06101 2.42639 2.72363 3.76377 2.72363 5.4135V10.2632C2.72363 11.913 4.06101 13.2503 5.71074 13.2503H10.6096C12.2593 13.2503 13.5967 11.913 13.5967 10.2632V5.4135C13.5967 3.76377 12.2593 2.42639 10.6096 2.42639Z",
    stroke: "white",
    strokeWidth: 1.15235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3957 5.39024C11.7946 5.39024 12.1179 5.06692 12.1179 4.66808C12.1179 4.26924 11.7946 3.94592 11.3957 3.94592C10.9969 3.94592 10.6736 4.26924 10.6736 4.66808C10.6736 5.06692 10.9969 5.39024 11.3957 5.39024Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8531_40129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.41193 17.0707) rotate(-90) scale(15.8569 14.7482)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8531_40129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.39121 6.95032 -28.6489 5.73789 -2.51857 0.989337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8531_40129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedMini);
export default __webpack_public_path__ + "static/media/feed_mini.3b2c06ddbb0715892d5aa17ee4429df0.svg";
export { ForwardRef as ReactComponent };